var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0967 34.5834H24.9022C30.694 34.5834 34.5837 30.5208 34.5837 24.4757V10.5245C34.5837 4.47936 30.694 0.416748 24.9039 0.416748H10.0967C4.30669 0.416748 0.416992 4.47936 0.416992 10.5245V24.4757C0.416992 30.5208 4.30669 34.5834 10.0967 34.5834ZM11.5192 15.7917C9.16402 15.7917 7.25033 13.8755 7.25033 11.5209C7.25033 9.16637 9.16402 7.25008 11.5192 7.25008C13.8727 7.25008 15.7881 9.16637 15.7881 11.5209C15.7881 13.8755 13.8727 15.7917 11.5192 15.7917ZM30.8609 22.5123C31.4329 23.9791 31.1357 25.742 30.5242 27.1947C29.7992 28.9225 28.4112 30.2306 26.6624 30.8018C25.886 31.0557 25.0717 31.1667 24.2591 31.1667H9.86176C8.42906 31.1667 7.16128 30.823 6.12198 30.183C5.47091 29.781 5.35581 28.8537 5.83853 28.2525C6.64593 27.2476 7.44301 26.2392 8.24697 25.222C9.7793 23.2756 10.8117 22.7115 11.9593 23.2069C12.4248 23.4114 12.8921 23.7181 13.3731 24.0425C14.6546 24.9134 16.436 26.1105 18.7826 24.8112C20.3884 23.9118 21.3198 22.3691 22.1309 21.0256L22.1445 21.0031C22.2019 20.9089 22.2589 20.8146 22.3157 20.7206C22.5883 20.2696 22.8572 19.8246 23.1614 19.4147C23.5428 18.9017 24.9566 17.2973 26.7878 18.4398C27.9543 19.1591 28.9352 20.1322 29.9848 21.1741C30.385 21.5726 30.6702 22.0257 30.8609 22.5123Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.081e8236bed914cd32641cfdc8d3a496.svg";
export { ForwardRef as ReactComponent };